import {
  CompanySiteType,
  mapCompanySiteType,
  useCreateCompanySite as useCreateCompanySiteApi,
} from '@api';
import { useNotification } from '@common';
import { AxiosError } from 'axios';
import { CreateCompanySiteType } from 'src/api/generated/touring/types';

const TRANS_KEY = 'NOTIFICATIONS.CREATE_COMPANY_SITE';

type UseCreateCompanySiteReturnType = {
  createCompanySite: (data: CreateCompanySiteType) => Promise<CompanySiteType>;
};

export const useCreateCompanySite = (
  companyId: string
): UseCreateCompanySiteReturnType => {
  const { showSuccess, showError } = useNotification();
  const { mutateAsync: createCompanySiteMutation } = useCreateCompanySiteApi();

  const onSuccess = async (): Promise<void> => {
    showSuccess({
      title: `${TRANS_KEY}.SUCCESS.TITLE`,
      message: `${TRANS_KEY}.SUCCESS.MESSAGE`,
    });
  };

  const onError = (error: AxiosError): void => {
    showError({
      title: `${TRANS_KEY}.ERROR.TITLE`,
      message: `${TRANS_KEY}.ERROR.MESSAGE`,
      error,
    });
  };

  const createCompanySite = async (
    data: CreateCompanySiteType
  ): Promise<CompanySiteType> => {
    const response = await createCompanySiteMutation(
      {
        companyId,
        data,
      },
      { onSuccess, onError }
    );
    return mapCompanySiteType(response.data);
  };

  return { createCompanySite };
};
